import { HttpMethods } from '@codametrix/ui-common';
import history from '../history';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { ExternalApplications } from './action-types';
import { showFeedback } from './ui';
import { AmplifyCore } from '@codametrix/ui-common';

const { paginationUtils } = AmplifyCore;

const selectExternalApplication = createAction<CMxAPI.ExternalApplication>(
  ExternalApplications.SELECT_EXTERNAL_APP
);

const selectExternalAppUser = createAction<CMxAPI.ExternalApplicationUser>(
  ExternalApplications.SELECT_EXTERNAL_APP_USER
);

const selectOrgnization = createAction<number>(
  ExternalApplications.SELECT_ORG_EXTERNAL_APP
);

const setStateToDefault = createAction<CMxAPI.ExternalApplicationUser>(
  ExternalApplications.SET_STATE_TO_DEFAULT
);

const listExternalApps = createAsyncThunk(ExternalApplications.LIST_EXTERNAL_APPS, async (
  params: AppProps.listParams,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const { sortablePageable, id } = params;

  var searchParams = paginationUtils.searchParamsFactory(sortablePageable);

  const pageableList = await api<
    CMxAPI.PageableList<CMxAPI.ExternalApplication>
  >({
    endpoint: `/externalApplication/list/v1?organizationId=${id}&${searchParams.toString()}`,
    init: {
      method: HttpMethods.GET
    }
  });

  return pageableList;
});

const listExternalAppUsers = createAsyncThunk(ExternalApplications.LIST_EXTERNAL_APP_USERS, async (
  params: AppProps.listParams,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const { sortablePageable, id } = params;

  var searchParams = paginationUtils.searchParamsFactory(sortablePageable);
  const pageableList = await api<
    CMxAPI.PageableList<CMxAPI.ExternalApplicationUser>
  >({
    endpoint: `/externalApplication/users/list/v1?externalApplicationName=${id}&${searchParams.toString()}`,
    init: {
      method: HttpMethods.GET
    }
  });

  return pageableList;
});

const saveExternalAppUser = createAsyncThunk(ExternalApplications.SAVE_EXTERNAL_APP_USER, async (
  params: CMxAPI.ExternalApplicationUser,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  try {
    const saved = await api<CMxAPI.ExternalApplicationUser>({
      endpoint: `/externalApplication/assign/v1`,
      init: {
        method: HttpMethods.POST
      },
      body: params
    });

    dispatch(
      showFeedback({
        id: Date.now(),
        message: `User Saved.`,
        dismissable: true,
        className: 'feedback-working'
      })
    );

    history.goBack();
    return saved;
  } catch (e: any) {
    return rejectWithValue(e);
  }
});

export const syncActions = {
  selectExternalApplication,
  selectExternalAppUser,
  selectOrgnization,
  setStateToDefault
};
const actions = { listExternalApps, listExternalAppUsers, saveExternalAppUser };
export default actions;
